import { render, staticRenderFns } from "./MetricWithGraph.vue?vue&type=template&id=b0efd612&scoped=true"
import script from "./MetricWithGraph.vue?vue&type=script&lang=ts"
export * from "./MetricWithGraph.vue?vue&type=script&lang=ts"
import style0 from "./MetricWithGraph.vue?vue&type=style&index=0&id=b0efd612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0efd612",
  null
  
)

export default component.exports